import AlocacaoPessoalView from "../../components/gestaoOrcamentaria/AlocacaoPessoalView";

export default function AlocacaoPessoal() {
  return <AlocacaoPessoalView tituloModulo="Alocação de Pessoal" />;
}
